<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>

import log from "./common/log";
import Vue from "vue";

export default {
    name: 'App',
    components: {},
    created() {
        this.$log.debug(this.$route);
        let lang = 'zh_cn';
        let zone = undefined;
        try {
            let res = navigator.language;
            if (res.substring(0, 2) == 'en') {
                res = 'en'
            } else if (res.substring(0, 2) == 'zh') {
                res = 'zh-cn'
            }
            lang = this.$Storage.get('lang');
            zone = this.$Storage.get('zone');
            if (!lang) {
                lang = res;
                lang = lang.toLocaleLowerCase().replace('-', '_');
            } else {
                lang = lang.toLocaleLowerCase().replace('-', '_');
            }
            if (!zone) {
                if (zone === 0) {
                    zone = 0
                } else if (zone === "") {
                    zone = this.$DateUtil.getZone();
                } else {
                    zone = this.$DateUtil.getZone();
                }
            }
        } catch (e) {
            this.$log.debug(e);
        }
        this.$Storage.set('lang', lang); // 设置全局语言
        this.$Storage.set('zone', zone); // 设置全局时区

        this._i18n.locale = lang;
    },
}
</script>

<style lang="scss">

</style>
